@if (showOverlay()) {
  <div
    class="fixed top-[80px] right-4 sm:right-6 z-[200] w-[calc(100vw-2rem)] max-w-[26rem]"
    role="region"
    aria-label="Multi-factor authentication reminder"
  >
    <div
      class="relative flex items-start gap-3 rounded-xl border border-[#e8eaec] dark:border-dark-grey bg-white dark:bg-surface-dark p-4 pr-9 shadow-[0_4px_24px_rgba(0,0,0,0.08),0_1px_3px_rgba(0,0,0,0.06)]"
    >
      <!-- Dismiss (X) — hides the reminder for the rest of the session -->
      <button
        type="button"
        (click)="onDismiss()"
        aria-label="Dismiss MFA reminder"
        class="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded text-dark-grey hover:text-dark dark:hover:text-white cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dark dark:focus-visible:ring-white"
      >
        <app-icon name="close" [size]="14" class="text-dark dark:text-white" />
      </button>

      <span
        class="flex shrink-0 items-center justify-center text-primary mt-0.5"
        aria-hidden="true"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>

      <div class="min-w-0 flex-1">
        <p class="m-0 text-sm font-medium text-dark dark:text-white">MFA not assigned</p>
        <p class="mt-0.5 text-xs leading-snug text-dark-grey dark:text-grey">
          @if (mfaGraceDays() !== null) {
            Add multi-factor authentication to enhance your account security.
            {{ mfaGraceDays() }} day(s) left before your account is deactivated.
          } @else {
            Add multi-factor authentication to enhance your account security.
          }
        </p>
        <app-button
          layout="secondary-outline"
          className="!h-8 !mt-3 !px-4 !text-xs whitespace-nowrap !min-w-0 !w-auto"
          (clicked)="onAssignMfa()"
        >
          Assign MFA
        </app-button>
      </div>
    </div>
  </div>
}
